<template>
    <div class="service">
        <div class="u-flex banner" :style="page_img ? {backgroundImage: 'url(' + page_img + ')'} : ''">
            <div class="container">
                <h4>企业服务</h4>
                <p class="mt20">品质服务、质量优先<br />一对一专业服务、定制您的个性化需求</p>
                <el-button class="fill" type="primary" round>填写需求</el-button>
            </div>
        </div>
        <div class="container">
            <div class="mt20 u-flex u-row-center tab">
                <div class="item" :class="{ 'active': tabIndex === index }" v-for="(item, index) in tabList"
                    :key="index" @click="onTab(index)">{{ item }}</div>
            </div>
            <div class="mt20 tab-content" v-if="tabIndex === 0">
                <el-form ref="customizationForm" :model="customizationForm" label-width="80px">
                    <div class="title">联系人信息</div>
                    <div class="mt20 u-flex row">
                        <el-form-item label="企业名称" prop="enterprise_name"
                            :rules="[{ required: true, message: '请输入企业名称', trigger: 'blur' }]">
                            <el-input v-model="customizationForm.enterprise_name" />
                        </el-form-item>
                        <el-form-item label="姓名" prop="name"
                            :rules="[{ required: true, message: '请输入姓名', trigger: 'blur' }]">
                            <el-input v-model="customizationForm.name" />
                        </el-form-item>
                        <el-form-item label="联系方式" prop="phone_number"
                            :rules="[{ required: true, message: '请输入联系方式', trigger: 'blur' }]">
                            <el-input type="number" v-model="customizationForm.phone_number" />
                        </el-form-item>
                    </div>
                    <div class="mt20 title">需求信息</div>
                    <div class="mt20 u-flex row">
                        <el-form-item label="提取频率">
                            <el-input-number v-model="customizationForm.extract_frequency" :step="1"></el-input-number>
                        </el-form-item>
                        <el-form-item label="单次提取数量(个)" label-width="130px">
                            <el-input-number v-model="customizationForm.single_trial" :step="1"></el-input-number>
                        </el-form-item>
                        <el-form-item label="每日总量(个)" label-width="108px">
                            <el-input-number v-model="customizationForm.daily_total_amount" :step="1"></el-input-number>
                        </el-form-item>
                    </div>
                    <el-form-item label="其他需求">
                        <el-input type="textarea" :rows="5" v-model="customizationForm.notes" placeholder="请输入您的需求" />
                        <div class="tips">请您尽可能详细地描述需求或反馈地内容哦~</div>
                    </el-form-item>
                </el-form>
                <div class="mt50 u-flex u-row-center">
                    <el-button class="submit" type="primary" round @click="onSubmitCustomization">提交需求</el-button>
                </div>
            </div>
            <div class="mt20 tab-content" v-else>
                <el-form ref="proxyPoolForm" :model="proxyPoolForm" label-width="90px">
                    <div class="title">联系人信息</div>
                    <div class="mt20 u-flex row">
                        <el-form-item label="企业名称" prop="enterprise_name" :rules="[{ required: true, message: '请输入企业名称', trigger: 'blur' }]">
                            <el-input v-model="proxyPoolForm.enterprise_name" />
                        </el-form-item>
                        <el-form-item label="姓名" prop="name" label-width="130px" :rules="[{ required: true, message: '请输入姓名', trigger: 'blur' }]">
                            <el-input v-model="proxyPoolForm.name" />
                        </el-form-item>
                        <el-form-item label="联系方式" prop="phone_number" label-width="108px" :rules="[{ required: true, message: '请输入联系方式', trigger: 'blur' }]">
                            <el-input type="number" v-model="proxyPoolForm.phone_number" />
                        </el-form-item>
                    </div>
                    <div class="mt20 title">需求信息</div>
                    <div class="mt20 u-flex u-flex-wrap row">
                        <el-form-item label="IP类型" prop="area_type" :rules="[{ required: true, message: '请选择IP类型', trigger: 'blur' }]">
                            <el-select v-model="proxyPoolForm.area_type"  placeholder="请选择地区" @change="onChangeArea">
                                <el-option
                                    v-for="item in [{ label: '国外', value: '0' }, { label: '国内', value: '1' }]"
                                    :key="item.value" :label="item.label" :value="item.value" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="地区" prop="area" :rules="[{ required: true, message: '请选择地区', trigger: 'blur' }]">
                            <el-select v-model="proxyPoolForm.area"   placeholder="请选择地区" >
                                <el-option
                                    v-for="item in areaList"
                                    :key="item.code" :label="item.area_name" :value="item.area_name" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="实时IP数量" label-width="130px">
                            <el-input-number v-model="proxyPoolForm.real_time_ip_quantity" :step="1"
                                placeholder="请输入您的实时IP数量" />
                        </el-form-item>
                        <el-form-item label="IP有效时常" >
                            <el-input v-model="proxyPoolForm.ip_valid_time" :step="1" placeholder="请输入您的IP有效时常" />
                        </el-form-item>
                        <el-form-item label="每日IP流水">
                            <el-input v-model="proxyPoolForm.daily_ip_flow" :step="1" placeholder="请输入您所需要的IP流水(个)" />
                        </el-form-item>
                    </div>
                    <el-form-item label="其他需求">
                        <el-input type="textarea" :rows="5" v-model="proxyPoolForm.notes" placeholder="请输入您的需求" />
                        <div class="tips">请您尽可能详细地描述需求或反馈地内容哦~</div>
                    </el-form-item>
                </el-form>
                <div class="mt50 u-flex u-row-center">
                    <el-button class="submit" type="primary" round @click="onSubmitProxyPool">提交需求</el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Index',
    data() {
        return {
            tabIndex: 0,
            tabList: ['代理IP定制', '代理池定制'],
            form: {},

            proxyForm: {

            },
            customizationForm: {
                enterprise_name: '',
                name: '',
                phone_number: '',
                extract_frequency: '',
                single_trial: '',
                daily_total_amount: ''
            },
            proxyPoolForm: {
                enterprise_name: '',
                name: '',
                phone_number: '',
                area_type:'',
                area: '',
                real_time_ip_quantity: '',
                ip_valid_time: '',
                daily_ip_flow: '',
                notes: '',
                
            },

          
            areaList: [],
            page_img:'',
        }
    },
    created() {
        this.$api.service.index({type:0}).then(res => {
            this.page_img = res.data.page_img
        })
    },
    methods: {
        
        onSubmitCustomization() {
            this.$refs.customizationForm.validate((valid) => {
                if (valid) {
                    // console.log(valid)
                    this.$api.service.submitCustomization(this.customizationForm).then(res => {
                        this.customizationForm = this.$options.data().customizationForm
                        this.$message.success('提交成功')
                    })
                } else {
                    return false
                }
            })
        },
        onSubmitProxyPool(){
            this.$refs.proxyPoolForm.validate((valid) => {
                if (valid) {
                    this.$api.service.submitProxyPool(this.proxyPoolForm).then(res => {
                        this.proxyPoolForm = this.$options.data().proxyPoolForm
                        this.areaList = []
                        this.$message.success('提交成功')
                    })
                }
            })
        },
        onTab(index) {
            this.tabIndex = index
        },
        onSubmit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    // console.log(valid)
                } else {
                    return false
                }
            })
        },
        onChangeArea(val) {
            this.areaList = []
            this.proxyPoolForm.area = ''
            this.$api.service.getAreaList({type:val}).then(res => {
                this.areaList = res.data
            })
        }

    }
}
</script>

<style scoped>
.service {
    padding: 20px 0 50px;
}

.banner {
    min-height: 500px;
    background: url(../assets/images/qyfw_bg.png) no-repeat 100%;
}

.banner h4 {
    color: #174d7c;
    font-size: 30px;
}

.banner p {
    line-height: 24px;
    color: #999;
    font-size: 16px;
}

.fill {
    margin-top: 20px !important;
    padding: 8px 20px;
    background: #2682ff;
}

.tab .item {
    padding: 16px 24px;
    color: #2682ff;
    cursor: pointer;
    border: 1px solid #2682ff;
}

.tab .active {
    color: #fff;
    background: #2682ff;
}

.tab-content {
    padding: 30px 20px;
    background: #fff;
    box-shadow: 2px 2px 20px 6px #f0f1f5;
}

.title {
    font-size: 16px;
    text-align: left;
}

.row .el-form-item {
    width: 33.3333%;
}

.tips {
    color: #999;
    font-size: 14px;
}

.submit {
    padding: 8px 30px;
    background: #2682ff;
}
</style>